import React from 'react';
import { X, ArrowRight } from '@phosphor-icons/react';
import WaterDroplet from '../Space/layouts/WaterDroplet';
import type { AmbientSuggestion } from '../../hooks/useAmbientSuggestions';
import './AmbientSuggestionBubble.scss';

interface AmbientSuggestionBubbleProps {
  suggestion: AmbientSuggestion;
  onAct: () => void;
  onDismiss: () => void;
}

const CATEGORY_LABELS: Record<string, string> = {
  follow_up: 'follow-up',
  deadline: 'deadline',
  insight: 'insight',
  pattern: 'pattern',
};

export const AmbientSuggestionBubble: React.FC<AmbientSuggestionBubbleProps> = ({
  suggestion,
  onAct,
  onDismiss,
}) => {
  return (
    <div className="ambient-suggestion-bubble">
      <div className="ambient-suggestion-bubble__inner">
        <div className="ambient-suggestion-bubble__avatar">
          <WaterDroplet size={14} />
        </div>
        <div className="ambient-suggestion-bubble__content">
          {suggestion.category && (
            <span className={`ambient-suggestion-bubble__category ambient-suggestion-bubble__category--${suggestion.category}`}>
              {CATEGORY_LABELS[suggestion.category] ?? suggestion.category}
            </span>
          )}
          <span className="ambient-suggestion-bubble__headline">{suggestion.headline}</span>
          <span className="ambient-suggestion-bubble__body">{suggestion.body}</span>
          {suggestion.reason && (
            <span className="ambient-suggestion-bubble__reason">{suggestion.reason}</span>
          )}
        </div>
        <div className="ambient-suggestion-bubble__actions">
          <button
            className="ambient-suggestion-bubble__btn ambient-suggestion-bubble__btn--dismiss"
            onClick={onDismiss}
            title="Not now"
          >
            Not now
          </button>
          <button
            className="ambient-suggestion-bubble__btn ambient-suggestion-bubble__btn--cta"
            onClick={onAct}
          >
            {suggestion.cta}
            <ArrowRight size={11} weight="bold" />
          </button>
        </div>
        <button
          className="ambient-suggestion-bubble__close"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          <X size={12} />
        </button>
      </div>
    </div>
  );
};
